// import React, { useMemo, useState } from "react";
// import {
//   ChevronLeft,
//   ChevronRight,
//   Coins,
//   ChevronUp,
//   ChevronDown,
// } from "lucide-react";
// import BottomNav from "../../components/BottomNav/BottomNav";
// import "./VipBonus.css";
// import InnerHeader from "../../components/InnerHeader";
// import { getBrandName } from "../../common/brand";
// import useTranslate from "../../hooks/useTranslate";

// export default function VipBonus({ globalData }) {
//   const { t } = useTranslate();

//   const vipLevels = [
//     {
//       level: t("vipNormal"),
//       cardTitle: t("vipSilver"),
//       depositText: `BDT 5,000.00 ${t("onwards")}`,
//       upgradeBonus: "50.00",
//       depositCurrent: 0,
//       depositTarget: 1000,
//       turnoverCurrent: 0,
//       turnoverTarget: 10000,
//     },
//     {
//       level: t("vipBronze"),
//       cardTitle: t("vipBronze"),
//       depositText: `BDT 1,000.00 ${t("onwards")}`,
//       upgradeBonus: "20.00",
//       depositCurrent: 100,
//       depositTarget: 1000,
//       turnoverCurrent: 1000,
//       turnoverTarget: 5000,
//     },
//     {
//       level: t("vipSilver"),
//       cardTitle: t("vipSilver"),
//       depositText: `BDT 5,000.00 ${t("onwards")}`,
//       upgradeBonus: "50.00",
//       depositCurrent: 0,
//       depositTarget: 5000,
//       turnoverCurrent: 0,
//       turnoverTarget: 20000,
//     },
//     {
//       level: t("vipGold"),
//       cardTitle: t("vipGold"),
//       depositText: `BDT 10,000.00 ${t("onwards")}`,
//       upgradeBonus: "100.00",
//       depositCurrent: 0,
//       depositTarget: 10000,
//       turnoverCurrent: 0,
//       turnoverTarget: 50000,
//     },
//     {
//       level: t("vipPlatinum"),
//       cardTitle: t("vipPlatinum"),
//       depositText: `BDT 25,000.00 ${t("onwards")}`,
//       upgradeBonus: "200.00",
//       depositCurrent: 0,
//       depositTarget: 25000,
//       turnoverCurrent: 0,
//       turnoverTarget: 150000,
//     },
//     {
//       level: t("vipDiamond"),
//       cardTitle: t("vipDiamond"),
//       depositText: `BDT 50,000.00 ${t("onwards")}`,
//       upgradeBonus: "400.00",
//       depositCurrent: 0,
//       depositTarget: 50000,
//       turnoverCurrent: 0,
//       turnoverTarget: 300000,
//     },
//   ];

//   const [activeIndex, setActiveIndex] = useState(0);
//   const [openTerms, setOpenTerms] = useState(true);
//   const [openFaqs, setOpenFaqs] = useState(false);
//   const [touchStartX, setTouchStartX] = useState(null);

//   const currentVip = vipLevels[activeIndex];

//   const goPrev = () => {
//     setActiveIndex((prev) => (prev === 0 ? vipLevels.length - 1 : prev - 1));
//   };

//   const goNext = () => {
//     setActiveIndex((prev) => (prev === vipLevels.length - 1 ? 0 : prev + 1));
//   };

//   const handleTouchStart = (e) => {
//     setTouchStartX(e.touches[0].clientX);
//   };

//   const handleTouchEnd = (e) => {
//     if (touchStartX === null) return;
//     const diff = e.changedTouches[0].clientX - touchStartX;

//     if (Math.abs(diff) > 40) {
//       if (diff > 0) goPrev();
//       else goNext();
//     }

//     setTouchStartX(null);
//   };

//   const progressPercent = useMemo(() => {
//     if (!currentVip.depositTarget) return 0;
//     return Math.min(
//       100,
//       Math.round((currentVip.depositCurrent / currentVip.depositTarget) * 100)
//     );
//   }, [currentVip]);

//   const privilegeColumns = [
//     t("vipNormal"),
//     t("vipBronze"),
//     t("vipSilver"),
//     t("vipGold"),
//     t("vipPlatinum"),
//     t("vipDiamond"),
//   ];

//   const privilegeRows = [
//     {
//       label: t("vip60DaysTurnover"),
//       values: ["0", "5000", "20000", "50000", "150000", "300000"],
//       dark: true,
//     },
//     {
//       label: t("totalDeposit"),
//       values: ["0", "1000", "5000", "10000", "25000", "50000"],
//       dark: false,
//     },
//     {
//       label: t("upgradeBonus"),
//       values: ["0", "20", "50", "100", "200", "400"],
//       dark: true,
//     },
//     {
//       label: t("upgradeBonusRate"),
//       values: ["1", "5", "5", "5", "5", "5"],
//       dark: false,
//     },
//     {
//       label: t("weeklyBonus"),
//       values: ["0", "0", "50", "100", "200", "300"],
//       dark: true,
//     },
//     {
//       label: t("weeklyBonusTurnover"),
//       values: ["0", "0", "5", "5", "5", "5"],
//       dark: false,
//     },
//     {
//       label: t("dailyTurnoverRatio"),
//       values: [
//         `${t("sports")}: 0.2%\n${t("casino")}: 0.2%\n${t("slots")}: 0.2%\n${t("other")}: 0.2%`,
//         `${t("sports")}: 0.001%\n${t("casino")}: 0.001%\n${t("slots")}: 0.001%\n${t("other")}: 0.001%`,
//         `${t("sports")}: 0.001%\n${t("casino")}: 0.001%\n${t("slots")}: 0.001%\n${t("other")}: 0.001%`,
//         `${t("sports")}: 0.002%\n${t("casino")}: 0.002%\n${t("slots")}: 0.002%\n${t("other")}: 0.002%`,
//         `${t("sports")}: 0.003%\n${t("casino")}: 0.003%\n${t("slots")}: 0.003%\n${t("other")}: 0.003%`,
//         `${t("sports")}: 0.004%\n${t("casino")}: 0.004%\n${t("slots")}: 0.004%\n${t("other")}: 0.004%`,
//       ],
//       dark: true,
//       multiline: true,
//     },
//     {
//       label: t("dailyTurnoverRate"),
//       values: ["20", "10", "10", "10", "10", "10"],
//       dark: false,
//     },
//     {
//       label: t("birthdayBonus"),
//       values: ["0", "10", "25", "50", "100", "200"],
//       dark: true,
//     },
//     {
//       label: t("birthdayBonusTurnoverRate"),
//       values: ["1", "2", "4", "4", "4", "4"],
//       dark: false,
//     },
//   ];

//   const brandName = getBrandName();

//   const termsText = [
//     t("vipTerms1"),
//     t("vipTerms2", { brandName }),
//     t("vipTerms3"),
//   ];

//   const faqItems = [
//     {
//       q: t("vipFaq1Q"),
//       a: t("vipFaq1A"),
//     },
//     {
//       q: t("vipFaq2Q"),
//       a: t("vipFaq2A"),
//     },
//   ];

//   return (
//     <div className="vipb-page">
//       <InnerHeader title={t("vipBonus")} />

//       <div className="vipb-shell">
//         <section className="vipb-banner">
//          
//         </section>

//         <div className="vipb-heading-row">
//           <span className="vipb-heading-line" />
//           <h2>{t("currentStatus")}</h2>
//           <span className="vipb-heading-line" />
//         </div>

//         <div className="vipb-status-text">{currentVip.level}</div>

//         <div className="vipb-progress-track">
//           <div
//             className="vipb-progress-fill"
//             style={{ width: `${progressPercent}%` }}
//           />
//         </div>

//         <div
//           className="vipb-carousel"
//           onTouchStart={handleTouchStart}
//           onTouchEnd={handleTouchEnd}
//         >
//           <button
//             type="button"
//             className="vipb-arrow vipb-arrow-left"
//             onClick={goPrev}
//             aria-label={t("previousLevel")}
//           >
//             <ChevronLeft size={28} />
//           </button>

//           <div className="vipb-slide-card">
//             <div className="vipb-slide-top">
//               <div className="vipb-coin-badge">
//                 <Coins size={22} />
//               </div>

//               <div className="vipb-slide-copy">
//                 <div className="vipb-slide-title">{currentVip.cardTitle}</div>
//                 <div className="vipb-slide-subtitle">{currentVip.depositText}</div>
//               </div>
//             </div>

//             <div className="vipb-slide-divider" />

//             <div className="vipb-slide-bottom">
//               {t("upgradeBonus")}: {currentVip.upgradeBonus}
//             </div>
//           </div>

//           <button
//             type="button"
//             className="vipb-arrow vipb-arrow-right"
//             onClick={goNext}
//             aria-label={t("nextLevel")}
//           >
//             <ChevronRight size={28} />
//           </button>
//         </div>

//         <div className="vipb-metrics">
//           <div className="vipb-metric-row">
//             <div className="vipb-metric-label">{t("depositRequirement")}:</div>
//             <div className="vipb-metric-box">
//               BDT {currentVip.depositCurrent} / BDT {currentVip.depositTarget}
//             </div>
//           </div>

//           <div className="vipb-metric-row">
//             <div className="vipb-metric-label">{t("turnoverRequirement")}:</div>
//             <div className="vipb-metric-box">
//               BDT {currentVip.turnoverCurrent} / BDT {currentVip.turnoverTarget}
//             </div>
//           </div>
//         </div>

//         <div className="vipb-privileges-title">{t("vipPrivileges")}</div>

//         <div className="vipb-table-scroll">
//           <div className="vipb-table-wrap">
//             <table className="vipb-table">
//               <thead>
//                 <tr>
//                   <th className="vipb-side-head" />
//                   {privilegeColumns.map((col) => (
//                     <th key={col}>{col}</th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {privilegeRows.map((row) => (
//                   <tr key={row.label} className={row.dark ? "vipb-row-dark" : "vipb-row-light"}>
//                     <td className="vipb-row-label">{row.label}</td>
//                     {row.values.map((value, idx) => (
//                       <td key={`${row.label}-${idx}`} className={row.multiline ? "vipb-multiline" : ""}>
//                         {row.multiline
//                           ? value.split("\n").map((line, i) => <div key={i}>{line}</div>)
//                           : value}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="vipb-accordion-wrap">
//           <button
//             type="button"
//             className="vipb-accordion-btn"
//             onClick={() => setOpenTerms((prev) => !prev)}
//           >
//             <span>{t("termsConditions")}</span>
//             {openTerms ? <ChevronUp size={26} /> : <ChevronDown size={26} />}
//           </button>

//           {openTerms && (
//             <div className="vipb-accordion-body">
//               {termsText.map((item, index) => (
//                 <p key={index}>{item}</p>
//               ))}
//             </div>
//           )}

//           <button
//             type="button"
//             className="vipb-accordion-btn"
//             onClick={() => setOpenFaqs((prev) => !prev)}
//           >
//             <span>{t("faqs")}</span>
//             {openFaqs ? <ChevronUp size={26} /> : <ChevronDown size={26} />}
//           </button>

//           {openFaqs && (
//             <div className="vipb-accordion-body">
//               {faqItems.map((item, index) => (
//                 <div key={index} className="vipb-faq-item">
//                   <div className="vipb-faq-q">{item.q}</div>
//                   <div className="vipb-faq-a">{item.a}</div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       <BottomNav />
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import "./VipBonus.css";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";

const VIPRebateScreen = () => {
  const navigate = useNavigate();
  const [vpValue, setVpValue] = useState("");
  const [showError, setShowError] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("token")
  );

  /* ============================= */
  /* HANDLE VP INPUT */
  /* ============================= */

  const handleVpChange = (e) => {
    const value = e.target.value;
    setVpValue(value);
    setShowError(value && value < 10);
  };

  /* ============================= */
  /* FETCH USER DATA */
  /* ============================= */

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem("token");
      const remoteId = localStorage.getItem("remote_id");

      if (token && remoteId) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/user/show?remote_id=${remoteId}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            setUserData(data);
          } else {
            console.error("Failed to fetch user data");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    if (isLoggedIn) {
      fetchUserData();
      const interval = setInterval(fetchUserData, 5000); // refresh every 5s
      return () => clearInterval(interval);
    }
  }, [isLoggedIn]);

  /* ============================= */
  /* CONVERT API CALL */
  /* ============================= */

  const handleConvert = async () => {
    const remoteId = localStorage.getItem("remote_id");
    const token = localStorage.getItem("token");

    if (!vpValue || vpValue < 10) {
      setModalMessage("Minimum VP Required: 10");
      setShowModal(true);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/convert-vipcoin?remote_id=${remoteId}&vip_coin=${vpValue}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        setModalMessage(data.success || "Conversion Successful");
        setVpValue("");
      } else {
        setModalMessage(data.message || "Conversion failed");
      }
    } catch (error) {
      console.error("Error converting VIP coins:", error);
      setModalMessage("Server error during conversion");
    } finally {
      setShowModal(true);
    }
  };

  /* ============================= */
  /* LOADING STATE */
  /* ============================= */

  if (loading) {
    return <div className="vp-loading">Loading...</div>;
  }

  /* ============================= */
  /* UI */
  /* ============================= */

  return (
    <>
    <Header />
   
    <div className="vp-container">
      <div className="profile-header ext">
        <h1>VIP Instant rebate</h1>
        <button onClick={() => navigate(-1)} className="close-btn">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
<div className="bdt-points">
      <div className="vp-minimum">
        Minimum VP requirement: <span>10</span>
      </div>

      {/* VP INPUT CARD */}
      <div className="vp-card">
        <div className="vp-card-content ext-content">
          <img width={28} src="https://img.b112j.com/bj/h5/assets/v3/images/icon-set/currency-type/vp.png?v=1770792598866&source=drccdnsrc" />

          <input
            type="number"
            value={vpValue}
            onChange={handleVpChange}
            className="vp-input"
            placeholder="0"
            min="0"
          />
        </div>

      </div>
       

      {/* CONVERTER ICON */}
      <div className="vp-convert-icon">
        <img width={18} src="https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-convert.svg?v=1770792598866"/>
      </div>

      {/* BDT OUTPUT CARD */}
      <div className="vp-card">
        <div className="vp-card-content">
          <div className="vp-icon">
          <img width={28} src="https://img.b112j.com/bj/h5/assets/v3/images/icon-set/currency-type/bdt.png?v=1770792598866&source=drccdnsrc" />

          </div>
          <div className="vp-output">
            {vpValue ? vpValue : 0}
          </div>
        </div>
      </div>
      {showError && (
          <div className="vp-error">
            Minimum 10 VP required
          </div>
        )}
      <div className="vp-ratio">
        1 VP = 1 BDT
      </div>

      <button
        className={`vp-claim-btn ${vpValue < 10 ? "vp-disabled" : ""
          }`}
        onClick={handleConvert}
      >
        Claim
      </button>
      <button className="point-btn-secondary vp-Record">View Record</button>

      {/* ================= Modal ================= */}
      {showModal && (
        <div className="vp-modal-overlay">
          <div className="vp-modal">
            <p>{modalMessage}</p>
            <button
              className="vp-modal-btn"
              onClick={() => setShowModal(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
    </div>
    <BottomNav />
    </>
  );
};

export default VIPRebateScreen;